import { ActionButtonProps } from './types';
import { StyledActionButton } from './style';
import { Stack } from '@mui/material';

function ActionButton({
    text,
    action,
    font,
    colors,
    textColor = 'white',
    border = 'none',
    icon = undefined
}: ActionButtonProps) {
    return (
        <StyledActionButton
            onClick={action}
            colors={colors}
            border={border}
            font={font}
        >
            <Stack
                style={{ color: textColor }}
                justifyContent="center"
                alignItems="center"
                direction="row"
                width="100%"
                gap="0.25em"
            >
                {
                    icon && <img alt="icon" src={icon}/>
                }
                {text}
            </Stack>
        </StyledActionButton>
    );
}

export default ActionButton;
